import ModalCustom from '../../UI/modal'
import Button from '../../UI/button'

type Props = {
	show: boolean
	handleClose: () => void
}
const CopyModal = ({show, handleClose}: Props) => {

  return (
	<ModalCustom show={show} onHide={handleClose} title='Copy The Folder'>
		<div className='d-flex justify-content-between align-items-center'>
			<Button width={180} size='md' variant='dark' onClick={handleClose}>
				Cancel
			</Button>
			<Button width={180} size='md' variant='primary'>
				Copy
			</Button>
		</div>
	</ModalCustom>
  )
}
export default CopyModal